import { IMappingObject } from './IMappingObject'

export const getDisplayValue = (
  allowedValues: IMappingObject | undefined,
  searchValue: string
): string => (allowedValues && allowedValues[searchValue]) ?? searchValue
